// Shared SVG string escaper — used across every reel format.
export const escape = (s) =>
    String(s ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");

// Shared brand palette so all reel formats stay on-brand.
export const BRAND = {
    ink: "#ffffff",
    inkDim: "#a1a1aa",
    inkFaint: "#52525b",
    bgTop: "#080808",
    bgBottom: "#020202",
    accent: "#a3e635",
    ocean: "#06b6d4",
    solar: "#f59e0b",
    violet: "#8b5cf6",
    line: "#1f1f22",
};

// Shared sponsor footer strip — appears at the bottom of any reel when a
// sponsor object is supplied. Renders "· THIS MONTH SPONSORED BY [NAME] ·"
// with a tiny circular initial as a mock logo. Real logos would be swapped in
// once a sponsor onboarding tool ships.
export const buildSponsorStrip = ({ sponsor, y, cx, color = BRAND.accent }) => {
    if (!sponsor) return "";
    const name = escape((sponsor.name || "").toUpperCase());
    const line = `THIS MONTH SPONSORED BY  ${name}`;
    const logo = sponsor.logo_data_url || sponsor.logo_url;
    const logoSvg = logo
        ? `<image x="-22" y="-22" width="44" height="44" href="${escape(logo)}" preserveAspectRatio="xMidYMid meet"/>`
        : `<circle cx="0" cy="0" r="18" fill="#0a0a0a" stroke="${color}" stroke-width="1.5"/>
           <text x="0" y="6" text-anchor="middle" fill="${color}" font-family="'Helvetica Neue', Arial, sans-serif" font-weight="800" font-size="18">${escape((sponsor.name || "S").charAt(0).toUpperCase())}</text>`;
    return `
  <g transform="translate(${cx} ${y})">
    <line x1="-300" y1="0" x2="-40" y2="0" stroke="${BRAND.line}" stroke-width="1"/>
    <line x1="40" y1="0" x2="300" y2="0" stroke="${BRAND.line}" stroke-width="1"/>
    <g transform="translate(0 26)">${logoSvg}</g>
    <text x="0" y="72" text-anchor="middle" fill="${BRAND.inkDim}" font-family="'Helvetica Neue', Arial, sans-serif" font-weight="600" font-size="14" letter-spacing="4">${line}</text>
  </g>`;
};
